(function () {
  function initArmaPackSimple(section) {
    if (!section) return;

    if (section.dataset.packSimpleInitialized === 'true') return;
    section.dataset.packSimpleInitialized = 'true';

    var buttons = section.querySelectorAll('.js-pack-add-btn');

    buttons.forEach(function (btn) {
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;

      var statusEl = btn
        .closest('.arma-pack-simple-card-body')
        .querySelector('.js-pack-status');

      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        btn.disabled = true;
        if (statusEl) {
          statusEl.textContent = 'Agregando a tu pack...';
          statusEl.classList.remove('arma-pack-simple-status--ok', 'arma-pack-simple-status--error');
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: parseInt(variantId, 10),
                quantity: 1
              }
            ]
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Error al agregar al carrito');
            return response.json();
          })
          .then(function () {
            if (statusEl) {
              statusEl.textContent = 'Añadido a tu pack ✨';
              statusEl.classList.add('arma-pack-simple-status--ok');
            }
            btn.disabled = false;
          })
          .catch(function () {
            if (statusEl) {
              statusEl.textContent = 'No se pudo agregar. Intenta nuevamente.';
              statusEl.classList.add('arma-pack-simple-status--error');
            }
            btn.disabled = false;
          });
      });
    });
  }

  function initAllPackSimpleSections() {
    var sections = document.querySelectorAll('.arma-pack-simple-section');
    sections.forEach(initArmaPackSimple);
  }

  document.addEventListener('DOMContentLoaded', initAllPackSimpleSections);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.arma-pack-simple-section');
    if (section) {
      initArmaPackSimple(section);
    }
  });
})();
